<template>
  <div class="animated fadeIn mb-4">
    <b-tabs card>
      <b-tab title="Analytes" active>
        <sample-analyte-table :trigger_approval_all="trigger_approval_all" :analytes="sample.analytes" />
      </b-tab>
      <b-tab title="Results" active>
        <sample-result-table :trigger_approval_all="trigger_approval_all" />
      </b-tab>
      <b-tab title="Prep">
        <sample-prep-table :trigger_approval_all="trigger_approval_all" />
      </b-tab>
      <b-tab title="Test">
        <sample-test-table :trigger_approval_all="trigger_approval_all" />
      </b-tab>
      <b-tab title="Test Packages">
        <sample-test-package-table />
      </b-tab>
      <b-tab title="Notes">
        <NotesDisplay :notes_attachable_id="$route.params.sample_id" notes_attachable_type="sample" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SamplePrepTable from "./SamplePrepTable";
import SampleResultTable from "./SampleResultTable";
import SampleTestPackageTable from "./SampleTestPackageTable";
import SampleTestTable from "./SampleTestTable";
import NotesDisplay from "@/components/shared/NotesDisplay.vue";
import SampleAnalyteTable from "./SampleAnalyteTable";

export default {
  name: "SampleDetailCardstack",
  components: {
    SampleResultTable,
    SamplePrepTable,
    SampleTestPackageTable,
    SampleTestTable,
    NotesDisplay,
    SampleAnalyteTable
  },
  props: {
    sample: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      trigger_approval_all: false
    };
  }
};
</script>
